@if (message) {
  @if (message.msgTitle) {
    <h2 mat-dialog-title>{{ message.msgTitle }}</h2>
  }
  <mat-dialog-content>
    @if (message.msgBegin && message.msgBegin !== '') {
      <div>
        {{
          isoFormatDMY(
            parseISOString($safeNavigationMigration(message?.msgBegin)),
            $safeNavigationMigration(message?.msgBegin)
          )
        }}
      </div>
    }
    @if (message.msgText && message.msgText !== '') {
      <div [innerHTML]="$safeNavigationMigration(message?.msgText)"></div>
    }
    @if (message.msgLinkText && message.msgLinkText !== '') {
      <a mat-button color="primary" tabindex="0" (click)="openLink()" (keyup.enter)="openLink()">
        {{ message.msgLinkText }}
      </a>
    }
    @if (message.msgSignature && message.msgSignature !== '') {
      <div>{{ message.msgSignature }}</div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()" cdkFocusInitial>Ok</button>
  </mat-dialog-actions>
}
